module.exports = __webpack_public_path__ + "static/fonts/Helvetica.e6633d7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Helvetica.eot
// module id = C9iC
// module chunks = 1